import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { MINUTES_TO_MILLIS } from "lopermut"
import { CampaignHealthResultsResponseDataSchema, DataResponse, OrganizationType } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof CampaignHealthResultsResponseDataSchema>>

type Query = {
  organizationTypes: OrganizationType[]
  search?: string
}

const getCampaignHealthQueryKey = (query: Query) => [
  "backoffice",
  "campaigns",
  "health",
  { organizationTypes: query.organizationTypes, search: query.search },
]

export const getCampaignHealthQuery = (query: Query) => {
  const organizationTypes = [...query.organizationTypes].sort()
  const params: Record<string, string> = {}
  if (organizationTypes.length > 0) params.organizationTypes = organizationTypes.join(",")
  if (query.search?.trim()) params.search = query.search.trim()

  return queryOptions({
    queryKey: getCampaignHealthQueryKey({ organizationTypes, search: query.search }),
    staleTime: 3 * MINUTES_TO_MILLIS,
    queryFn: async () => {
      const { data } = await axios.get<Response>("/backoffice/campaigns/health", {
        params: Object.keys(params).length > 0 ? params : undefined,
      })
      return data.data
    },
  })
}
